import styles from "./ContactSelector.module.scss";

const SelectedContactItem = ({ contact, onRemove }) => {
  const getActivityLevel = (rfqs7d) => {
    if (rfqs7d > 5) return 'high';
    if (rfqs7d > 0) return 'medium';
    return 'low';
  };

  const activityLevel = getActivityLevel(contact.rfqs_7d);

  return (
    <div className={styles.selectedContactItem}>
      <div className={styles.contactCheckbox}>
        <button
          className={styles.removeButton}
          onClick={() => onRemove(contact.id)}
          type="button"
        >
          ×
        </button>
      </div>
      
      <div className={styles.contactInfo}>
        {contact.email && (
          <div className={styles.contactEmail}>
            {contact.email}
          </div>
        )}
        {contact.phone && (
          <div className={styles.contactPhone}>
            {contact.phone}
          </div>
        )}
        {contact.name && (
          <div className={styles.contactName}>
            {contact.name}
          </div>
        )}
        {contact.customer_name && (
          <div className={styles.customerName}>
            {contact.customer_name}
          </div>
        )}
      </div>

      <div className={styles.activitySection}>
        <div className={`${styles.activityIndicator} ${styles[activityLevel]}`}>
          <div className={styles.activityDot}></div>
        </div>
        <div className={styles.rfqStats}>
          <div className={styles.statItem}>
            <span className={styles.statLabel}>7d:</span>
            <span className={styles.statValue}>{contact.rfqs_7d || 0}</span>
          </div>
          <div className={styles.statItem}>
            <span className={styles.statLabel}>30d:</span>
            <span className={styles.statValue}>{contact.rfqs_30d || 0}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectedContactItem;